<template>
    <div class="row section-explain justify-content-center">
        <div class="col-12 col-sm-6 col-lg-4">
            <img class="icon" src="/assets/icons/chat.svg" height="40" alt="Our Blog"/>
            <h3 class="font-md">Our Blog</h3>
            <p>Read about the latest travel tips, luxury property updates and more!</p>
            <a href="http://landing.ultimatejetvacations.com/blog" class="link-style">Read more <i class="material-icons">keyboard_arrow_right</i></a>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
            <img class="icon" src="/assets/icons/questions.svg" height="40" alt="FAQ"/>
            <h3 class="font-md">FAQ</h3>
            <p>Get the answers to UJV’s most frequently asked questions.</p>
            <a href="/faq" class="link-style">Read more <i class="material-icons">keyboard_arrow_right</i></a>
        </div>
    </div>
</template>

<script>

    export default {
        mounted() {

        }
    }

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>